import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-drug-names',
  templateUrl: './view-drug-names.component.html',
  styleUrl: './view-drug-names.component.scss'
})
export class ViewDrugNamesComponent {
  drugNames: string[] = [];
  isCancelDisabled = true;

  constructor(
    public dialogRef: MatDialogRef<ViewDrugNamesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.item && Array.isArray(data.item.drug_names)) {
      this.drugNames = data.item.drug_names;
    }
  }

  ngOnInit() {
    this.isCancelDisabled = false;
  }

  close(): void {
    this.dialogRef.close();
  }
}
